module.exports = __webpack_public_path__ + "static/blogImg-d4205bef216e6fd9c995c21556f80145.jpg";